<!-- Integrer le header -->
<!-- partial:partials/_navbar.html -->
<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
   <div class="navbar-brand-wrapper d-flex align-items-center" >
    <a class="" routerLink="/accueil">
      <img src="../../assets/images/biblio-logo.png" alt="logo" class="img-logo" />
    </a>
    <a class="navbar-brand brand-logo-mini" routerLink="/accueil"><img src="../../assets/images/biblio-logo.png" alt="logo" /></a>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-center flex-grow-1">
    <h5 class="mb-0 font-weight-medium d-none d-lg-flex titre-initial text-success">{{ 'app-title' | translate}}</h5>
      <h4 class="typing ml-3 text-danger mt-2 titre-initial ">
          {{ 'app-title-dev' | translate}}
      </h4>

    <ul class="navbar-nav navbar-nav-right ml-auto">
      <li class="nav-item dropdown">
        <a class="nav-link count-indicator message-dropdown" id="messageDropdown" routerLink="/about">
          <i class="icon-info text-dark"></i>
        </a>
      </li>
      <!--<li class="nav-item dropdown language-dropdown d-none d-sm-flex align-items-center">
        <a class="nav-link d-flex align-items-center dropdown-toggle" id="LanguageDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
          <span class="profile-text font-weight-normal" >{{ 'lngApp' | translate}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-left navbar-dropdown py-2" aria-labelledby="LanguageDropdown">
          <a class="dropdown-item" (click)="switchLanguage('fr')">
             {{ 'lngFr' | translate}} </a>
          <a class="dropdown-item" (click)="switchLanguage('en')">
             {{ 'lngEn' | translate}}</a>
        </div>
      </li>-->
      <li class="nav-item dropdown language-dropdown d-none d-sm-flex align-items-center">
        <a class="nav-link dropdown-toggle" id="UserDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
          <span class="font-weight-normal"> {{prenomAdmin}} {{nomAdmin}}</span></a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown w-100" aria-labelledby="UserDropdown">
          <!--<a  class="dropdown-item"><i class="dropdown-item-icon icon-user text-primary"  ></i>{{groupeAdmin}}</a>-->
          <a (click)="logout()" class="dropdown-item"><i class="dropdown-item-icon icon-power text-primary"  ></i> {{'login.logout-text' | translate }}</a>
        </div>
      </li>
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
      <span class="icon-menu"></span>
    </button>
  </div>
</nav>

